var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "rotate(180 9.5 9.5)",
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44199 4.26576C9.26899 3.93876 8.73099 3.93876 8.55799 4.26576L4.05799 12.7658C4.01749 12.8419 3.9974 12.9273 3.9997 13.0136C4.00201 13.0998 4.02661 13.184 4.07112 13.2579C4.11563 13.3319 4.17853 13.393 4.25369 13.4354C4.32885 13.4777 4.41371 13.4999 4.49999 13.4998H13.5C13.5862 13.4999 13.671 13.4778 13.7461 13.4354C13.8212 13.3931 13.8841 13.332 13.9286 13.2581C13.973 13.1842 13.9976 13.1001 13.9999 13.0139C14.0021 12.9277 13.982 12.8424 13.9415 12.7663L9.44199 4.26576ZM9.49999 11.9998H8.49999V10.9998H9.49999V11.9998ZM8.49999 9.99976V7.49976H9.49999L9.50049 9.99976H8.49999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0db65d20178f789adbf996082cccf171.svg";
export { ForwardRef as ReactComponent };